import Scroller from 'vux/src/components/scroller/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'integral',
directives: {
TransferDom
},
components: {
Scroller,
},
data () {
return {
integralTotal: 0,
list: [],
page: 1,
postStatus: '未完成',
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
}
},
methods: {
getIntegralTotal () {
this.$request.post('/Integral/totalByUserId',{

}).then(data => {
if(data.code == 0){
this.integralTotal = data.obj
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
fetchData(cb) {
this.$request.post('/Integral/listIntegral',{
page: this.page,
rows: 10,
}).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
}
},
created () {
this.getIntegralTotal()
},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
}



// WEBPACK FOOTER //
// ./src/views/integral/script.js